import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import { Row, Col, Table, Button, Tab, Tabs } from 'react-bootstrap';
import product from '../product.js';
import DetailImg from '../component/DetailImg';
import Exchange from '../component/Exchange';
import Qna from '../component/Qna';
import Review from '../component/Review';
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { addItem } from '../store.js';
import { useDispatch } from 'react-redux';


const Detail = (props) => {
    let [clickup, setClickup] = useState(1);
    let {id} = useParams();
    let dispatch = useDispatch();
    let navigate = useNavigate();


    return (
        <>
            <Header></Header>

            <div className='detail_wrap'>
                <Row>
                    <Col lg={5}>
                        
                        <img src={process.env.PUBLIC_URL + "/img/c" + (Number(id)+1) + ".jpg"} width="100%" alt='의류' />
                    </Col>
                    <Col lg={5}>
                        <Table striped>
                            <thead>
                                <tr>
                                    <th colSpan={2}>
                                        <p>{props.product[id].title_kr}</p>
                                        <p>{"₩" + props.product[id].price.toLocaleString()}</p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>혜택 / 리뷰</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>구매 혜택가</td>
                                    <td><span>{"₩" + ((props.product[id].price-12000).toLocaleString())}</span> (신규회원 + PAYCO 첫결제)</td>
                                </tr>
                                <tr>
                                    <td>구매 혜택</td>
                                    <td className='img_td'>
                                        <img src={process.env.PUBLIC_URL + "/img/cupon.jpg"} alt='cupon' />
                                        <Button variant="outline-dark" onClick={
                                            () => {
                                                navigate('/Login')
                                                return (
                                                    alert("로그인 후 이용 가능합니다.")
                                                )
                                            }
                                        }>쿠폰받기</Button>
                                        <p>무료배송/반품/교환 가능</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>상품 리뷰</td>
                                    <td>★ 5.0 ( 7개의 리뷰 )</td>
                                </tr>
                                <tr>
                                    <td>수량</td>
                                    <td className='num'>
                                    <Button variant="outline-dark" onClick={()=>{
                                        setClickup(clickup-1);
                                        if(clickup === 1){
                                            alert("최소 수량입니다.");
                                            setClickup(clickup);
                                        }
                                    }}>
                                        －
                                    </Button>
                                    <span>{clickup}</span>
                                    <Button variant="outline-dark" onClick={()=>{
                                        setClickup(clickup+1);
                                    }}>
                                        ＋
                                    </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        <div className='detail_btn_wrap'>
                            <Button variant="secondary" onClick={()=>{
                                dispatch(addItem({type : 'addObj' ,id : props.product[id].id, name : props.product[id].title_kr, price : props.product[id].price, count:1}));
                                alert("장바구니에 상품을 담았습니다.")
                            }}>CART</Button>
                            <Button variant="primary" onClick={()=>{
                                navigate('/CART');
                                dispatch(addItem({type : 'addObj', id : props.product[id].id, name : props.product[id].title_kr, price : props.product[id].price, count:1}));
                                alert("장바구니 페이지로 이동합니다.")
                            }}>BUY</Button>
                        </div>
                    </Col>
                </Row>

                <Tabs
                    defaultActiveKey="detail"
                    transition={false}
                    id="noanim-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="detail" title="상품 상세 정보">
                        <DetailImg />
                    </Tab>
                    <Tab eventKey="review" title="상품 후기">
                        <Review />
                    </Tab>
                    <Tab eventKey="qna" title="상품 문의">
                        <Qna />
                    </Tab>
                    <Tab eventKey="exchange" title="교환/반품">
                        <Exchange />
                    </Tab>
                </Tabs>
            </div>


            <Footer></Footer>
        </>
    )
}


export default Detail;